import { checkVoid } from "./formatDateDisplay";
import Tooltip from "./Tooltip";

export function FormatNumberSpan({
  value,
  format,
  position,
}: {
  value?: number;
  format?: string;
  position?:
    | "right-0"
    | "left-0"
    | "right-2/6"
    | "bottom-0"
    | "left-2/6"
    | "bottom-1"
    | "bottom-4"
    | "top-6"
    | "top-6 right-0"
    | "top-[-25px] left-2/6 -translate-x-[-5%]";
}) {
  const formatCurrency = format || "en-IN";

  const num = value || 0;
  const numValue = num.toLocaleString(formatCurrency, {
    maximumFractionDigits: 2,
  });
  const toolTipNumValue = num.toLocaleString(formatCurrency, {
    maximumFractionDigits: 4,
  });
  if (num >= 10000000000 && formatCurrency === "en-IN") {
    return (
      <Tooltip text={toolTipNumValue} _position={position}>
        <span>{`${(num / 10000000000).toLocaleString(formatCurrency, {
          maximumFractionDigits: 2,
        })}K Cr`}</span>
      </Tooltip>
    );
  } else if (num >= 10000000 && formatCurrency === "en-IN") {
    return (
      <Tooltip text={toolTipNumValue} _position={position}>
        <span>{`${(num / 10000000).toLocaleString(formatCurrency, {
          maximumFractionDigits: 2,
        })} Cr`}</span>
      </Tooltip>
    );
  } else if (num >= 100000 && formatCurrency === "en-IN") {
    return (
      <Tooltip key="format" text={toolTipNumValue} _position={position}>
        <span>{`${(num / 100000).toLocaleString(formatCurrency, {
          maximumFractionDigits: 2,
        })} L`}</span>
      </Tooltip>
    );
  } else if (num >= 1000000000 && formatCurrency !== "en-IN") {
    return (
      <Tooltip text={toolTipNumValue} _position={position}>
        <span>{`${(num / 1000000000).toLocaleString(formatCurrency, {
          maximumFractionDigits: 2,
        })} B`}</span>
      </Tooltip>
    );
  } else if (num >= 1000000 && formatCurrency !== "en-IN") {
    return (
      <Tooltip text={toolTipNumValue} _position={position}>
        <span>{`${(num / 1000000).toLocaleString(formatCurrency, {
          maximumFractionDigits: 2,
        })} M`}</span>
      </Tooltip>
    );
  } else {
    return (
      <Tooltip text={toolTipNumValue} _position={position}>
        <span>{numValue}</span>
      </Tooltip>
    );
  }
}
